import { useContext, createContext } from 'react';

const TabsContext = /*#__PURE__*/createContext({});
const useTabsContext = () => {
  return useContext(TabsContext);
};

export { TabsContext, useTabsContext };
